/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_Create_Company_LabelInputs */

const en_admin_user_create_company_label = /** @type {(inputs: Admin_User_Create_Company_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company`)
};

const de_admin_user_create_company_label = /** @type {(inputs: Admin_User_Create_Company_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmen`)
};

/**
* | output |
* | --- |
* | "Company" |
*
* @param {Admin_User_Create_Company_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_create_company_label = /** @type {((inputs?: Admin_User_Create_Company_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_Create_Company_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_create_company_label(inputs)
	return en_admin_user_create_company_label(inputs)
});